import React, { useState, useEffect } from "react";
import axios from "axios";
import { Dialog } from "primereact/dialog";
import { Form, Col, Badge, Row } from 'react-bootstrap';
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { useAuth } from "../context/AuthContext";
import config from "../config";
import { InputTextarea } from "primereact/inputtextarea";
import { Accordion, AccordionTab } from 'primereact/accordion';
import GifLoder from "../components/GifLoder";
import noUserImg from "../assets/images/no_user.png";
import { Dropdown } from 'primereact/dropdown'; // Assuming you are using PrimeReact
const SalaryStatus = ({ slipIds, onclose }) => {
    const { accessToken, userId } = useAuth();
    const [loading, setLoading] = useState(false);

    const [signatures, setSignatures] = useState([]);
    const [selectedSignature, setSelectedSignature] = useState({ id: null, url: '' });
    const [status, setStatus] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState(null);

    const statusOptions = [
        { label: "Sent", value: "Sent" },
        { label: "Cancelled", value: "Cancelled" },
    ];

    const paymentOptions = [
        { label: "Payment Due", value: "Payment_due" },
        { label: "Paid", value: "Paid" },
        { label: "Partial Paid", value: "Partial_paid" },
    ];


    useEffect(() => {
        const fetchSignatures = async () => {
            try {
                const response = await axios.get(`${config.apiBASEURL}/letterRoutes/fetch-signatures/${userId}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.status === 200) {
                    setSignatures(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching signatures:', error);
            }
        };

        if (userId) fetchSignatures();
    }, [userId, accessToken]);


    const handleSubmit = async () => {
        if (!status) {
            return;
        }

        setLoading(true);
        try {
            const payload = {
                slipIds: slipIds.map((emp) => emp.slNo), // map to IDs
                status,
                payment_status: paymentStatus,
                signature_url: selectedSignature?.url,
            };

            const response = await axios.put(
                `${config.apiBASEURL}/Salary_Generation_Routes/monthly-slips/status`,
                payload,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );

            if (response.status === 200) {
                onclose();
            }
        } catch (error) {
            console.error("❌ Failed to update:", error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="loderDiv">
            <GifLoder />
        </div>;
    }

    return (
        <>
            <Row className="mx-0 pt-4">
                <h6 className="mb-4 pb-3 border-bottom">Finalize Salary Disburstment</h6>
                <Col md={12} lg={5} className="mb-4 gap-0">
                    <h6>Selected Employees</h6>

                    {slipIds.map((emp) => (
                        <div key={emp.slNo} className="d-flex align-items-center gap-2 mb-3">
                            <img
                                src={emp.profile_image || noUserImg}
                                alt={emp.name}
                                className="rounded-full"
                                style={{
                                    width: "40px",
                                    height: "40px",
                                    objectFit: "cover",
                                    borderRadius: "50%",
                                }}
                            />
                            <div style={{ width: "calc(100% - 40px)" }}>
                                <span>{emp.name}</span>
                                <small className="d-block">
                                    <span>Generated By: {emp.createdby}</span>
                                </small>
                            </div>
                        </div>
                    ))}
                </Col>

                <Col md={12} lg={7} className="mb-4 gap-3">
                    <div className="sticky-top" style={{ top: "15px" }}>
                        <Accordion activeIndex={0} >
                            <AccordionTab header="Signature">
                                <Form.Label>Admin Signature</Form.Label>
                                <Dropdown
                                    value={selectedSignature}
                                    options={signatures.map((signature) => ({
                                        label: `Signature ${signature.signature_file_id}`,  // Display a label for the signature
                                        value: { id: signature.signature_file_id, url: signature.signature_url }, // Set both ID and URL as value
                                    }))}
                                    onChange={(e) => setSelectedSignature(e.value)} // Store the selected signature's id and url
                                    optionLabel="label" // Option text from label
                                    placeholder="Select Signature"
                                    filter
                                    filterBy="label"
                                    className="w-full"
                                />
                                {selectedSignature.url && (
                                    <div className="mt-3">
                                        <img
                                            src={selectedSignature.url}
                                            alt="Signature Preview"
                                            style={{ maxWidth: '100%', maxHeight: '200px' }}
                                        />
                                    </div>
                                )}
                            </AccordionTab>
                            <AccordionTab header="Salary Slip Status">
                                <Form.Label>Status</Form.Label>
                                <Dropdown
                                    value={status}
                                    options={statusOptions}
                                    onChange={(e) => setStatus(e.value)}
                                    placeholder="Select Status"
                                    className="w-full"
                                />
                            </AccordionTab>
                            <AccordionTab header="Payment Status">
                                <Form.Label>Payment Status</Form.Label>
                                <Dropdown
                                    value={paymentStatus}
                                    options={paymentOptions}
                                    onChange={(e) => setPaymentStatus(e.value)}
                                    placeholder="Select Payment Status"
                                    className="w-full"
                                />
                            </AccordionTab>
                        </Accordion>
                        <div className="mb-0 d-flex justify-content-end gap-2 mt-3">
                            <Button
                                label="Cancel"
                                icon="pi pi-times"
                                severity="secondary"
                                onClick={onclose}
                                className="py-2"
                            />

                            <Button
                                label="Save"
                                icon="pi pi-check"
                                severity="success"
                                onClick={handleSubmit}
                                loading={loading}
                                className="py-2"
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default SalaryStatus